// @flow

import Service from "app/services/Service";

class GlobalSettingsService extends Service {
    static base = "/admin";

    update(param: string, value: any): Promise<*> {
        return this.http.put(
            "/settings/" + param,
            this.toSearchParams({ value })
        );
    }
}

export default new GlobalSettingsService();



// WEBPACK FOOTER //
// ./src/app/services/GlobalSettingsService.js